module.exports = __webpack_public_path__ + "static/img/nav_bg.30361b7a.png";